var app = angular.module("leonardo");


var UserEditController = function ($scope, $window, $state, $q, Upload, ConfigThemeService, ngDialog, $rootScope, PermissionService, AuthService,
                                   NotificationService, FolderFileService, AuthDataService, AccountUserService,
                                   FormErrorsService, FileService, UserService, AttachmentService, AccountService, AnalyticsService) {


  $scope.user = angular.copy(AuthService.user);
  $scope.authDataService = AuthDataService;
  $scope.error = false;
  $scope.errorSize = false;
  $scope.old_email = angular.copy(AuthService.user.email);
  $scope.old_file = {};
  $scope.attachments = [];
  $scope.account_user_info = [];
  $scope.permissionService = PermissionService;
  $scope.accountObj = null;
  UserService.get($scope.user.id).then(function (data) {
    $scope.user = data;
    angular.forEach($scope.user.account_users, function (account_user) {
      AccountUserService.get(account_user.id).then(function (item) {
        $scope.account_user_info.push({
          account_id: item.account,
          account_user_id: item.id,
          preferences: {
            notify_note_important: !isNull(item.preferences.notify_note_important) ? item.preferences.notify_note_important : 1,
            // notify_property_critical: !isNull(item.preferences.notify_property_critical) ? item.preferences.notify_property_critical : 1,
          },
          time_zone: item.time_zone,
          wants_approval_summary_notifications: item.wants_approval_summary_notifications
        });
      });
      if (isNull(account_user.managed_by) && !isNull(account_user.account)) {
        AccountService.get(account_user.account).then(function(res) {
          $scope.accountObj = res;
        });
      }
    });
    $scope.initAttachments();
  });



  $scope.toggleUser = function (user_id) {
    $scope.userExpanded = $scope.userExpanded === user_id ? null : user_id;
  };


  $scope.userIsExpanded = function (user_id) {
    return $scope.userExpanded && ($scope.userExpanded === user_id);
  };


  $scope.userIsExpanded = function (user_id) {
    return $scope.userExpanded && ($scope.userExpanded === user_id);
  };


  $scope.initAttachments = function () {
    if ($scope.user.image) {
      FolderFileService.getFileObject($scope.user.image, function (fileObject) {
        var array_url = $scope.user.image.split('/');
        var file = new FileService([fileObject], array_url[array_url.length - 1], {type: 'image/' + array_url[array_url.length - 1].split('.')[1]});
        $scope.user.image = file;
        var fd = new FormData();
        fd.append('file', file);
        $scope.user.image.file = fd;
        $scope.attachments.push(file);
        $scope.old_file = file;
      });
    }
  };

  $scope.onFileUpload = function (file) {
    if (!file) {
      return;
    }
    $scope.errorSize = AttachmentService.checkErrorSize(file);
    if ($scope.errorSize) {
      return;
    }
    $scope.user.image = file;
    var fd = new FormData();
    fd.append('file', file);
    $scope.user.image.file = fd;
    $scope.attachments.push(file);
  };

  $scope.remove = function ($index) {
    $scope.errorSize = false;
    $scope.attachments.splice($index, 1);
    $scope.user.image = null;
  };

  $scope.getOptions = function () {
    return {color: ConfigThemeService.config.theme_config.successColor};
  };

  $scope.submit = function () {
    $scope.error = false;
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    var data = {};
    if ($scope.user.image && ($scope.old_file !== $scope.user.image))
      data = {
        first_name: $scope.user.first_name,
        last_name: $scope.user.last_name,
        email: $scope.user.email,
        title: $scope.user.title,
        image: $scope.user.image,
        preferred_language: $scope.user.preferred_language ? parseInt($scope.user.preferred_language) : null,
      };
    else
      data = {
        first_name: $scope.user.first_name,
        last_name: $scope.user.last_name,
        email: $scope.user.email,
        title: $scope.user.title,
        image: ($scope.user.image === $scope.old_file) ? $scope.old_file : null,
        preferred_language: $scope.user.preferred_language ? parseInt($scope.user.preferred_language) : null,
      };
    data.account_user_info = JSON.stringify($scope.account_user_info);
    Upload.upload({
      url: ConfigThemeService.generateURL('/api/2.0/users/' + $scope.user.id + '/'),
      data: data,
      method: 'PATCH'
    }).then(function (result) {
      if ($scope.old_email !== $scope.user.email) {
        AuthService.tokenRefresh(result.data.token);
      }
      AnalyticsService.identifyUser($scope.user, $scope.authDataService.authData);
      NotificationService.notify('success', 'Changes updated correctly');
      AuthService.user = result.data;
      AccountUserService.getCurrent();
    }, function () {
      $scope.error = true;
      NotificationService.error('An unexpected error has occurred.');
    });
  };

  $scope.showPasswordDialog = function () {
    ngDialog.open({
      template: 'views/templates/dialog/account-user/change-password.html',
      controller: 'ChangePasswordDialog',
      data: {
        user: $scope.user
      }
    });
  };

  $scope.share = function () {
    $scope.FormShare.$setSubmitted();
    if ($scope.FormShare.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    AuthDataService.authData.accountsManager[0].share({to: $scope.user_alias}).then(function () {
      $scope.user_alias = '';
      $scope.FormShare.$submitted = false;
      NotificationService.notify('success', 'Your alias have been sent.');
    }, function (error) {
      NotificationService.error('An unexpected error has occurred.');
    });
  };

};

app.controller('UserEditController', ['$scope', '$window', '$state', '$q', 'Upload', 'ConfigThemeService', 'ngDialog', '$rootScope',
  'PermissionService', 'AuthService', 'NotificationService', 'FolderFileService', 'AuthDataService', 'AccountUserService',
  'FormErrorsService', 'FileService', 'UserService', 'AttachmentService', 'AccountService', 'AnalyticsService', UserEditController]);
